<template>
  <footer class="site-footer">
    <div class="content-max-width md:flex column">

      <div class="footer-links md:flex md:flex-between">

        <div class="logo">
          <a href="/"><img src="/images/footer-logo.svg" alt="Cass Medical"></a>
          <span>Proud member of MTANZ and in association with Connected Healthcare</span>
          <img :src="data.logo1" alt="" class="med-tech">
          <img :src="data.logo2" alt="" class="med-tech">
        </div>

        <div class="contact md:flex md:flex-between">
          <div class="col">
            <p>Cass Medical Ltd</p>
            <p v-html="data.address"></p>
            <p><a :href="data.phone.link">{{ data.phone.value }}</a></p>
          </div>
          <div class="col col-2">
            <p>Business hours</p>
            <p>Monday to Friday: 9:00am - 5:00pm<br/>Saturday and Sunday: Closed<br/>Public holidays: Closed</p>
          </div>
          <div class="col col-3" style="width: 253px !important;">
            <h5>Certifications:</h5>
            <img :src="data.logo3" alt="" class="connected">
            <img :src="data.logo4" alt="" class="connected">
          </div>
        </div>

      </div>
      <div class="footer-legal md:flex">

        <p class="copyright">Copyright 2022 Cass Medical</p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank" class="attribution"
        >
          Web design by Brownpaperbag
        </a>

      </div>

    </div>
  </footer>
</template>

<script>
export default {
  props: [
    'data'
  ]
};
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue